export default "__VITE_ASSET__D2gkC55f__"